import { graphql } from 'gatsby';
import React from 'react';
import { mapToPageModel } from '../mappers/page.mapper';
import { Page } from '../models';
import { Helmet } from 'react-helmet';
import favicon from '../images/favicon.ico';

const Cookies = ({ data: nodePage }) => {
  const pageData: Page = mapToPageModel(nodePage.nodePage);

  return (
    <section className="vl-region">
      <Helmet>
        <title>Cookieverklaring | Barometer samenleven</title>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      </Helmet>
      <div className="vl-layout">
        <h1 className="vl-title vl-title--h2">{pageData.title}</h1>
        <p
          className="vl-u-spacer-bottom  vl-typography"
          dangerouslySetInnerHTML={{ __html: pageData.body }}
        />
      </div>
    </section>
  );
};

export default Cookies;

export const query = graphql`
  query getNodePageCookies {
    nodePage(id: { eq: "b3e71b0f-d145-5317-8b9e-2863823338db" }) {
      body {
        processed
      }
      title
      id
    }
  }
`;
